import React from "react";
import "./ContextPanel.css";

/**
 * ContextPanel
 * Right-side panel showing live learning context.
 *
 * Props:
 *  - mode : "tutor" | "buddy"
 *  - data : { topic, difficulty, pct, lastConcept, count }
 */
const ContextPanel = ({ mode = "tutor", data = {} }) => {
  const { topic, difficulty, pct = 0, lastConcept, count = 0 } = data;

  return (
    <aside className={`tcp-ctx tcp-ctx--${mode}`} aria-label="Learning Context">
      <div className="tcp-ctx__header">Learning Context</div>

      <div className="tcp-ctx__body">
        <div className="tcp-ctx__row">
          <label className="tcp-ctx__label">Current Topic</label>
          <p className="tcp-ctx__value">{topic || "—"}</p>
        </div>

        <div className="tcp-ctx__row">
          <label className="tcp-ctx__label">Difficulty</label>
          <p className="tcp-ctx__value">{difficulty || "—"}</p>
          <div className="tcp-ctx__bar">
            <div className="tcp-ctx__bar-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>

        <div className="tcp-ctx__row">
          <label className="tcp-ctx__label">Last Concept</label>
          <p className="tcp-ctx__value tcp-ctx__value--muted">{lastConcept || "None yet"}</p>
        </div>

        <div className="tcp-ctx__row">
          <label className="tcp-ctx__label">AI Mode</label>
          <p className="tcp-ctx__value">
            {mode === "tutor" ? "Strict Tutor" : "Friendly Buddy"}
          </p>
        </div>

        <div className="tcp-ctx__row">
          <label className="tcp-ctx__label">Questions Asked</label>
          <p className="tcp-ctx__value">{count}</p>
        </div>
      </div>
    </aside>
  );
};

export default ContextPanel;